import graphql__aa07bfeffa88ba0cff54 from "./__generated__/ParticipativeModuleRouteQuery.graphql.js";import { graphql } from "react-relay";
import { useParams } from "react-router";
import AppQueryRenderer from "../AppQueryRenderer";

import ParticipativeModule from "../ParticipativeModule/ParticipativeModule";

const ParticipativeModuleRoute = props => {
  const { participativeModuleSlug } = useParams();

  return (
    <AppQueryRenderer
      key={participativeModuleSlug}
      query={ParticipativeModuleRouteQuery}
      variables={{ participativeModuleSlug }}
      component={ParticipativeModule}
      additionalProps={props}
    />
  );
};

const ParticipativeModuleRouteQuery = graphql__aa07bfeffa88ba0cff54;

export default ParticipativeModuleRoute;
